import { load } from './load';
import { THRID_CHANNLE, THRID_CHANNLE_NAME } from '../config';

let accountApi: any = null;
let liAccountApi: any = null;

export const initAccountApi = () => {
  load(process.env.REACT_APP_INTL_ACCOUNT_SDK || '', (script, err) => {
    if (!err) {
      accountApi = new (window as any).IntlgameAccountApi({
        env: process.env.REACT_APP_INTL_ACCOUNT_SDK_ENV, // sdk运行的环境
        gameID: 29_134,
      });

      liAccountApi = new (window as any).IntlgameAccountApi({
        env: process.env.REACT_APP_INTL_ACCOUNT_SDK_ENV, // sdk运行的环境
        hostCAcc: process.env.REACT_APP_INTL_ACCOUNT_SDK_HOST_ACC,
        langType: window?.navigator?.language || 'en', // 语言
        appID: '304953b95531249e24a5dcb5104e5ed7', // 自建账号appid
        accountPlatType: 131, // 自建账号平台id
        gameID: 29_134,
        hostINTL: process.env.REACT_APP_INTL_ACCOUNT_SDK_HOST_INTL,
      });
    }
  });
};

export const loadSecurityScript = () =>
  new Promise((resolve, reject) => {
    load('https://camp.honorofkings.com/h5/library/camp-security-oversea.0.0.1.js', (script, error) => {
      if (error) {
        reject(error);
      }
      resolve(script);
    });
  });

/**
 * 通过第三方社交账号登陆游戏账号
 * @param channel 社交平台渠道
 * @param channel_info 社交平台信息
 * @returns 登陆结果
 */
export const intlThirdLogin = async (channel, channel_info) =>
  await accountApi
    ?.intlAuthorize({
      third_type: channel,
      channel_info,
    })
    .catch(() => null);

/**
 * 跳转到第三方平台登录
 * @returns
 */
export const JumpToThridLogin = async (channel: THRID_CHANNLE) => {
  const res = await accountApi
    ?.thirdAuthorize({
      third_type: THRID_CHANNLE_NAME[channel],
    })
    .catch((error) => {
      console.log(error);
    });

  console.log('thirdAuthorize', res);

  if (channel === THRID_CHANNLE.TWITTER) {
    return {
      channel,
      oauth_token: res.access_token,
      oauth_secret: res.secret,
      ...res,
    };
  }

  if (channel === THRID_CHANNLE.VK) {
    return {
      channel,
      token: res.access_token,
      ...res,
    };
  }
  return {
    channel,
    ...res,
  };
};

/**
 * 查询某个邮箱是否注册过游戏账号
 * @param email 邮箱账号
 * @returns boolean 是否注册过游戏账号
 */
export const queryEmailUserName = async (email: string) => {
  const res = await liAccountApi
    ?.queryRegisterStatus({
      account: email,
      account_type: 1,
    })
    .catch(() => null);
  if (res) {
    console.log('queryRegisterStatus', res);
    return res;
  }
  return false;
};

/**
 * 向邮箱发送验证码
 * @param email 邮箱地址
 * @returns 发送是否成功
 */
export const emailSendVerifyCode = async (email: string) => {
  const res = await liAccountApi
    ?.requestVerifyCode({
      account: email,
      account_type: 1,
      code_type: 2,
    })
    .catch(() => null);
  return res?.ret === 0;
};

/**
 * 通过email和验证码登陆intl账号
 * @param email 邮箱地址
 * @param code 验证码
 */
export const verifyCodeRegister = async (email: string, code: string) => {
  return await liAccountApi
    ?.verifyCodeRegister({
      account: email,
      account_type: 1,
      verify_code: code,
    })
    .catch(() => null);
};

/**
 * 通过email登陆的intl账号登陆到游戏账号
 * @param email 邮箱账号
 * @param token intl账号token
 * @param openid intl账号openid
 */
export const intlSignIn = async (email: string, token: string, openid: string) => {
  return await liAccountApi
    ?.intlSignIn({
      token: token,
      openid: openid,
      account_plat_type: 131,
      account: email,
    })
    .catch(() => null);
};
